import { Flex } from 'antd'

import { useNavigate } from '@suntex.core/nav'
import { GoalsIndexChart } from '@suntex.fim/assessment'
import { isAuthenticated, useAuth } from '@suntex.fim/auth/react'
import {
  $EntityLevel,
  $GoalsIndexPhase,
  ChartSource,
  EntityLevel,
  GoalsIndexPhase,
  SpecialGradeLevel
} from '@suntex.fim/enums'
import { useOptionalPlayerContext } from '@suntex.fim/player'
import { useOptionalTeamContext } from '@suntex.fim/team'

function GoalIndexChartWrapper({
  id,
  level,
  year,
  phase,
  grade,
  from,
  entityLevel
}: {
  id: number
  level: EntityLevel
  year: string
  phase: GoalsIndexPhase
  grade: SpecialGradeLevel
  from?: ChartSource
  entityLevel?: EntityLevel
}) {
  const navigate = useNavigate()
  const teamCtx = useOptionalTeamContext()
  const team = teamCtx?.teamInfo ?? null
  const { login } = useAuth(isAuthenticated)
  const school = teamCtx?.schoolInfo ?? null
  const schoolName = school?.schoolStats.schoolName
  const playerInfo = useOptionalPlayerContext()?.playerInfo ?? null

  return (
    <Flex vertical justify="center" align="center">
      <GoalsIndexChart
        id={id}
        level={level}
        year={year}
        phase={phase}
        grade={grade}
        showLegend={true}
        onChartClick={() => {
          if (from === ChartSource.Dashboard) {
            let navId = team?.id ?? login.entityId
            if (entityLevel === EntityLevel.School) {
              navId = login.schoolId
            }
            let navigationUrl = `/${$EntityLevel.describe(entityLevel ?? EntityLevel.Team).slug}/${navId}`
            if (entityLevel === EntityLevel.Player) {
              navigationUrl = `/player/my-goals`
            } else {
              navigationUrl = `${navigationUrl}/assessment-report/goals-index?initialPhase=${$GoalsIndexPhase.describe(phase).slug}`
            }
            navigate(navigationUrl)
          }
        }}
      />
      {from === ChartSource.Dashboard &&
        (entityLevel === EntityLevel.School ? (
          <div className="right fw-bold">{schoolName}</div>
        ) : (
          entityLevel === EntityLevel.Team && (
            <Flex gap={5} align="center">
              <div className="right fw-bold">
                {team?.name ?? playerInfo?.team?.teamName}
              </div>
              <div className="right fw-bold">
                {team?.className
                  ? `| ${team.className}`
                  : `| ${playerInfo?.team?.className}`}
              </div>
            </Flex>
          )
        ))}
    </Flex>
  )
}

export default GoalIndexChartWrapper
